import { Heightfield } from '../terrain/heightfield'
import { ObstacleField } from '../physics/obstacles'
import type { SlopePayload } from './generate.worker'

/**
 * Rebuild the live objects from a worker payload. The buffers arrive
 * transferred, so this is a rewrap rather than a copy.
 */
export interface LiveSlope {
  hf: Heightfield
  obstacles: ObstacleField
  payload: SlopePayload
}

export function rebuildSlope(p: SlopePayload): LiveSlope {
  const hf = new Heightfield(p.minX, p.minZ, p.width, p.length, p.cell)
  hf.height.set(p.height)
  hf.snowWeights.set(p.snowWeights)
  hf.rock.set(p.rock)
  hf.concavity.set(p.concavity)
  hf.exposure.set(p.exposure)
  hf.trap.set(p.trap)
  hf.sluffProne.set(p.sluffProne)

  const obstacles = new ObstacleField()
  for (const o of p.obstacles) obstacles.add({ ...o })


  return { hf, obstacles, payload: p }
}
